<div class="card-body">
    <div id="apex-stacked-bars-100-chart"></div>
</div>